<template>
  <b-container>
    <b-row align-h="center" class="text-center">
      <b-col md="8" class="text-left">
        <b-card header-tag="header">
          <b-row slot="header" class="mb-0" align-v="center">
            <b-col md="6" sm="4">{{ accountInfo.velaeasyDomain }}</b-col>
            <b-col class="text-right">
              <b-button size="sm" variant="outline-secondary" v-on:click="confirmLogoutModal">
                {{ $t('_logout') }}
              </b-button>
            </b-col>
          </b-row>
          <b-form>
            <category-input></category-input>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="LogoutModal" :title="$t('_logout')">
      <p>{{ $t('modal_confirm_logout') }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" v-on:click="confirmLogout">
          {{ $t('_logout') }}
        </b-btn>
        <b-btn size="sm" class="float-right" variant="light" v-on:click="LogoutModal=false">
          {{ $t('_cancel') }}
        </b-btn>
      </div>
    </b-modal>
  </b-container>
</template>

<script>

import CategoryInput from '@/components/CategoryInput'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EditInfo',
  data () {
    return {
      LogoutModal: false
    }
  },
  components: {
    CategoryInput
  },
  computed: {
    ...mapGetters([
      'accountInfo',
      'shappyInfo'
    ])
  },
  methods: {
    ...mapActions([
      'logoutAPI',
      'getShopAuthTokenAPI'
    ]),
    confirmLogoutModal () {
      this.LogoutModal = true
    },
    confirmLogout () {
      let param = {'appID': this.shappyInfo.appId,
        'channelID': this.shappyInfo.channelId,
        'customToken': this.shappyInfo.customToken,
        'domain': this.shappyInfo.domain
      }
      this.logoutAPI(param).then((result) => {
        this.$router.push({
          name: 'login'
        })
      })
    },
    loginToShopWeb () {
      let param = {'appID': this.shappyInfo.appId,
        'channelID': this.shappyInfo.channelId,
        'customToken': this.shappyInfo.customToken,
        'domain': this.shappyInfo.domain
      }
      this.getShopAuthTokenAPI(param).then((result) => {
        window.open(process.env.VUE_APP_SHOP_WEB_URL + 'login/' + result.shopAuthToken, '_blank')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.button-go-to-shop {
  margin-right: 10px;
}
</style>
